export const IMPORTERS_LIST_REQUEST = "IMPORTERS_LIST_REQUEST";
export const IMPORTERS_LIST_RESPONSE = "IMPORTERS_LIST_RESPONSE";

export const EXPORTERS_LIST_REQUEST = "EXPORTERS_LIST_REQUEST";
export const EXPORTERS_LIST_RESPONSE = "EXPORTERS_LIST_RESPONSE";

export const GET_IMPORTER_DETAILS_REQUEST =
  "GET_IMPORTER_DETAILS_REQUEST";
export const GET_IMPORTER_DETAILS_RESPONSE =
  "GET_IMPORTER_DETAILS_RESPONSE";

export const GET_EXPORTER_COMPANY_DETAILS_REQUEST =
  "GET_EXPORTER_COMPANY_DETAILS_REQUEST";
export const GET_EXPORTER_COMPANY_DETAILS_RESPONSE =
  "GET_EXPORTER_COMPANY_DETAILS_RESPONSE";

export const GET_EXPORTER_CONTACT_INFO_REQUEST =
  "GET_EXPORTER_CONTACT_INFO_REQUEST";
export const GET_EXPORTER_CONTACT_INFO_RESPONSE =
  "GET_EXPORTER_CONTACT_INFO_RESPONSE";

export const GET_EXPORTER_VERIFICATION_INFO_REQUEST =
  "GET_EXPORTER_VERIFICATION_INFO_REQUEST";
export const GET_EXPORTER_VERIFICATION_INFO_RESPONSE =
  "GET_EXPORTER_VERIFICATION_INFO_RESPONSE";

export const GET_EXPORTER_TRANSACTIONS_LIST_REQUEST =
  "GET_EXPORTER_TRANSACTIONS_LIST_REQUEST";
export const GET_EXPORTER_TRANSACTIONS_LIST_RESPONSE =
  "GET_EXPORTER_TRANSACTIONS_LIST_RESPONSE";

export const GET_COMPANY_CONTACT_INFO_REQUEST =
  "GET_COMPANY_CONTACT_INFO_REQUEST";
export const GET_COMPANY_CONTACT_INFO_RESPONSE =
  "GET_COMPANY_CONTACT_INFO_RESPONSE";

export const GET_EXPORTER_ACCOUNT_INFO_REQUEST =
  "GET_EXPORTER_ACCOUNT_INFO_REQUEST";
export const GET_EXPORTER_ACCOUNT_INFO_RESPONSE =
  "GET_EXPORTER_ACCOUNT_INFO_RESPONSE";

export const BLOCK_IMPORTER_REQUEST = "BLOCK_IMPORTER_REQUEST";
export const UNBLOCK_IMPORTER_REQUEST = "UNBLOCK_IMPORTER_REQUEST";

export const COMBINED_LIST_REQUEST = "COMBINED_LIST_REQUEST";
export const COMBINED_LIST_RESPONSE = "COMBINED_LIST_RESPONSE";
